import React from "react";
import { Box, Flex, Text, HStack, Tag, TagLabel } from "@chakra-ui/react";
import { ChapterHeading, Reveal, MotionBox, glass } from "./story";

const milestones = [
  {
    date: "Oct 2023 to Present",
    loc: "Kolkata, West Bengal",
    org: "letsworkwise",
    title: "Software Engineer",
    stack: ["Next.js", "Node.js", "PostgreSQL", "AWS"],
    description: `The chapter I'm living now. As the founding software engineer, I turned letsworkwise, a B2B procurement platform, from an outsourced project into a product we own. I lead the architecture, ship features from start to finish, and I'm growing the engineering team from the ground up.`,
  },
  {
    date: "Mar 2023 to Jul 2023",
    loc: "Bangalore, Karnataka",
    org: "Salesken",
    title: "Software Engineer Intern",
    stack: ["React", "Bootstrap", "jQuery"],
    description: `My first taste of production. Working alongside senior engineers, I built application interfaces and absorbed the industry practices (code review, collaboration, shipping under real constraints) that shaped me into a professional engineer.`,
  },
  {
    date: "Jul 2020 to Dec 2022",
    loc: "Remote",
    org: "GeeksforGeeks",
    title: "Technical Content Writer",
    stack: ["JavaScript", "Python", "Java", "C"],
    description: `Where it all began. I authored 150+ search friendly technical articles, explaining everything from JavaScript to WordPress. Teaching thousands of readers taught me clarity, a skill I now bring to every codebase and every team.`,
  },
];

export default function WorkExperiance() {
  return (
    <Box id="Work Experiance" py={{ base: "80px", md: "120px" }} px={{ base: "6%", md: "9%" }}>
      <ChapterHeading
        chapter="Chapter 03 · The Journey"
        title="From writing about code to shipping it"
        subtitle="Three roles, read from newest to first. The path that got me here."
      />

      <Box maxW="820px" mx="auto" position="relative">
        {/* the road */}
        <Box
          position="absolute"
          left={{ base: "9px", md: "50%" }}
          top="0"
          bottom="0"
          w="2px"
          transform={{ md: "translateX(-50%)" }}
          bgGradient="linear(to-b, #60A5FA, rgba(96,165,250,0.15))"
        />

        {milestones.map((m, i) => (
          <Reveal
            key={i}
            delay={0.05}
            dir={i % 2 === 0 ? "left" : "right"}
            position="relative"
            pl={{ base: "40px", md: 0 }}
            mb="34px"
          >
            {/* node */}
            <Box
              position="absolute"
              left={{ base: "2px", md: "50%" }}
              top="14px"
              w="18px"
              h="18px"
              transform={{ md: "translateX(-50%)" }}
              borderRadius="full"
              bg="#0C111B"
              border="3px solid #60A5FA"
              boxShadow="0 0 14px rgba(96,165,250,0.7)"
              zIndex={1}
            />

            <Flex justify={{ md: i % 2 === 0 ? "flex-start" : "flex-end" }}>
              <MotionBox
                whileHover={{ y: -4 }}
                transition={{ type: "spring", stiffness: 250 }}
                {...glass({ p: { base: "20px", md: "26px" } })}
                w={{ base: "100%", md: "46%" }}
              >
                <Text fontSize="11px" fontWeight="700" color="#60A5FA" letterSpacing="0.1em">
                  {m.date}
                </Text>
                <Text fontSize={{ base: "lg", md: "xl" }} fontWeight="800" color="#f0f2f7" mt="4px">
                  {m.title}
                </Text>
                <Text fontSize="sm" color="#98a2b8" fontWeight="600">
                  {m.org} · {m.loc}
                </Text>
                <Text mt="12px" fontSize="sm" color="#c2c9d6" lineHeight="1.85">
                  {m.description}
                </Text>
                <HStack mt="14px" flexWrap="wrap" spacing="8px">
                  {m.stack.map((s) => (
                    <Tag
                      key={s}
                      size="sm"
                      bg="rgba(96,165,250,0.1)"
                      color="#93C5FD"
                      border="1px solid rgba(96,165,250,0.25)"
                      borderRadius="full"
                      mb="6px"
                    >
                      <TagLabel>{s}</TagLabel>
                    </Tag>
                  ))}
                </HStack>
              </MotionBox>
            </Flex>
          </Reveal>
        ))}
      </Box>
    </Box>
  );
}
